import GridSquareBox from "./grid-square.styles";

/**
 * The base component for the square grid system.
 * A square container with no styling for the content
 */
const GridSquare = GridSquareBox;

export default GridSquare;
